'use client';

import React from 'react';

import Link from '@/components/ui/link';

import BackgroundGridWrapper from '@/components/background-grid-wrapper';

export default function Footer() {
  return (
    <footer className="relative flex h-full min-h-[40vh] flex-col justify-between bg-black px-[5%] py-10 md:min-h-[60vh]">
      {/* <BackgroundGridWrapper className="border-white/10"> */}
      <Link href="/contact" prefetch={true} className="group flex flex-col">
        <div className="font-nohemi text-[4rem] leading-[1] text-white uppercase md:text-[9rem] lg:text-[13.5rem]">
          Let&apos;s Chat
        </div>
        <div className="relative h-4 w-0 bg-white transition-all duration-1000 ease-in-out group-hover:w-[90%]"></div>
      </Link>
      <div className="grid w-full grid-cols-2 justify-between gap-x-4">
        <div className="flex h-full w-full flex-col gap-y-6 border-t border-white/10 py-8">
          <div className="font-general-sans text-xl font-medium text-white uppercase">
            Social
          </div>
          <div className="flex flex-col gap-y-2">
            <Link
              href="https://www.linkedin.com/in/gambhirpiyush"
              target="_blank"
              rel="noopener noreferrer"
              className="font-general-sans text-base font-normal text-white/70 transition-all duration-300 ease-in-out hover:text-white"
            >
              LinkedIn
            </Link>
            <Link
              href="https://twitter.com/_piyushgambhir"
              target="_blank"
              rel="noopener noreferrer"
              className="font-general-sans text-base font-normal text-white/70 transition-all duration-300 ease-in-out hover:text-white"
            >
              X (Twitter)
            </Link>
            <Link
              href="https://www.instagram.com/_piyushgambhir"
              target="_blank"
              rel="noopener noreferrer"
              className="font-general-sans text-base font-normal text-white/70 transition-all duration-300 ease-in-out hover:text-white"
            >
              Instagram
            </Link>
          </div>
        </div>
        <div className="flex h-full w-full flex-col gap-y-4 border-t border-white/10 py-8">
          <div className="font-general-sans text-xl font-medium text-white uppercase">
            Contact
          </div>
          <div className="flex flex-col gap-y-2">
            <Link
              href="mailto:hello@piyushgambhir.com"
              className="font-general-sans text-base font-normal text-white/70 transition-all duration-300 ease-in-out hover:text-white"
            >
              Email
            </Link>
            <Link
              href="tel:+91123456789"
              className="font-general-sans text-base font-normal text-white/70 transition-all duration-300 ease-in-out hover:text-white"
            >
              Phone
            </Link>
          </div>
        </div>
      </div>
      {/* </BackgroundGridWrapper> */}
    </footer>
  );
}
